import React, { useState, useEffect } from 'react';
import './clients.css';
import api, { baseURL } from '../../axiosInstance';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton, TextareaAutosize, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useMediaQuery } from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { Link, useNavigate } from "react-router-dom";
import { Send, Close } from "@mui/icons-material";
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { nanoid } from "nanoid";
import { CancelOutlined } from "@mui/icons-material";
import EmailIcon from '@mui/icons-material/Email';
import VerifiedIcon from '@mui/icons-material/Verified';
import axios from 'axios';
import addProduct from '../../Assets/icon/productIcon.svg'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';



function Clients() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();


  const parent_id = sessionStorage.getItem('userid');

  const [formData, setFormData] = useState({
    parent_id,
    type: 2,
    name: '',
    username: '',
    // firstname:'',
    lastname: '',
    // password: '',
    email: '',
    phone: '',
    address: '',
    language: 'English',
    organisation: '',
    country_id: '',
  });

  const [showForm, setShowForm] = useState(false);
  const [clients, setClients] = useState([]);
  const [editingClientId, setEditingClientId] = useState(null);
  const [originalData, setOriginalData] = useState(null);
  const [page, setPage] = useState(1);
  const [clientPage, setClientPage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uniqueLink, setUniqueLink] = useState("");
  const [errors, setErrors] = useState({});
  const [countrylist, setCountryList] = useState([])



  // Fetch clients
  useEffect(() => {
    fetchClients(page);

  }, [page]);

  useEffect(() => {
    fetchCountry()
  }, [])

  const fetchClients = async () => {
    try {
      const response = await api.get(`/distributorchild/${parent_id}/2?page=${page}`);
      const filteredlink = response.data.meta.links.filter(link => /^[0-9]+$/.test(link.label))
      const updatedfilteredlinks = filteredlink.map(link => ({
        ...link,
        active: parseInt(link.label) == page
      }))
      setClientPage(updatedfilteredlinks)
      setClients(response.data.data || []);


    } catch (error) {
      console.error('Error fetching clients:', error);
    }
    setLoading(false);

  };
  console.log("response client", clients)

  const fetchCountry = async () => {
    try {
      const countryresponse = await axios.get(`${baseURL}/listcountries`)
      console.log("ountryresponse", countryresponse.data.data)
      setCountryList(countryresponse.data.data)
    }
    catch (error) {
      console.log("error", error)
    }

  }

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'radio' ? Number(value) : value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }))

  };

  // const validateForm = () => {
  //   console.log(" validateForm",formData )
  //   let newErrors = {}
  //   if (formData.email) {
  //     if (!formData.username) newErrors.username = "Username is required";
  //      console.log("validateForm error", newErrors)

  //     // if (!formData.firstname) newErrors.firstname = "Firstname is required";
  //     if (!formData.lastname) newErrors.lastname = "Lastname is required";
  //   }


  //   setErrors(newErrors)
  //   return Object.keys(newErrors).length==0

  // }

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const response = editingClientId
  //       ? await api.put(`/distributor/${editingClientId}`, formData)  // Update
  //       : await api.post('/distributor', formData);  // Add new

  //     if (response.status === 200) {
  //       alert('Form submitted successfully!');
  //       fetchClients(); // Refresh client list
  //       setShowForm(false); // Show table after submission
  //       setFormData({ parent_id, type: 2, name: '', password: '', email: '', phone: '', address: '' });
  //       setEditingClientId(null);
  //     }
  //   } catch (error) {
  //     alert(`Error: ${error?.response?.data?.error}`);
  //     console.error(error);
  //   }
  // };

  console.log("client formdata", formData)


  const handleFormSubmit = (e) => {
    e.preventDefault();
    // if (validateForm()) {
    handleSubmit(formData);
    // }
  };

  const handleSubmit = async (formData) => {

    try {
      const cleanedFormData = Object.keys(formData).reduce((acc, key) => {
        if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined) {
          acc[key] = formData[key];
        }
        return acc;
      }, {});
      if (editingClientId) {
        // Compare formData with originalData and send only changed fields
        // const updatedFields = Object.keys(formData).reduce((acc, key) => {

        //   if (formData[key] !== originalData[key] || key=="name") {
        //     acc[key] = formData[key];
        //   }
        //   return acc;
        // }, {});
        // const updatedFields = {
        //   type: formData.type, 

        //   ...Object.keys(formData).reduce((acc, key) => {
        //     if (formData[key] !== originalData[key] ) {
        //       acc[key] = formData[key];
        //     }
        //     return acc;
        //   }, {})
        // };
        const editfield = ["parent_id", "type", "name", "username", "lastname", "email", "phone", "address", "language",
          "organisation", "country_id"]

        const filteredit = Object.fromEntries(
          Object.entries(formData).filter(([key]) => editfield.includes(key))

        )

        const hasEmptyField = Object.values(filteredit).some(
          value => value == null || value == undefined || value == ""
        )

        if (hasEmptyField) {
          Swal.fire('Please fill all the fields.', '', 'warning');
          return;
        }


        // if (Object.keys(updatedFields).length === 0) {
        //   // alert('No changes detected.');
        //   Swal.fire('No changes detected.', '', 'info');
        //   return;
        // }

        // Send only changed fields
        const response = await api.put(`/distributor/${editingClientId}`, filteredit);

        if (response.status === 200) {
          // alert('Client updated successfully!');
          Swal.fire('Success!', 'Client updated successfully!', 'success');

          fetchClients(page); // Refresh the list
          setShowForm(false);
          setEditingClientId(null);
          setOriginalData(null);
        }
      } else {
        // Add new client

        console.log("cleanedFormData", cleanedFormData)

        const response = await api.post('/distributor', cleanedFormData);
        if (response.status === 200) {
          // alert('Client added successfully!');
          // Swal.fire('Success!', 'Client added successfully!', 'success');
          Swal.fire({
            title: "Success!",
            text: "Client added successfully!",
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Add Product",
            cancelButtonText: "Cancel",
          }).then((result) => {
            if (result.isConfirmed) {
              // 👉 Add Product button clicked
              navigate(`/selltoclient/${response.data?.data?.id}`);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              // 👉 Cancel button clicked
              console.log("User canceled");
              fetchClients(page);
              setShowForm(false);
            }
          });


        }
      }

      // Reset form
      setFormData({
        parent_id,
        type: 2,
        name: '',
        username: '',
        lastname: '',
        email: '',
        phone: '',
        address: '',
        organisation: '',
        language: 'English'
      });
    } catch (error) {
      // alert(`Error: ${error?.response?.data?.error}`);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.error || "Something went wrong!",
      });
      console.error(error);
    }
  };

  // const handleEdit = (client) => {
  //   setFormData(client);
  //   setEditingClientId(client.id);
  //   setShowForm(true);
  // };
  const handleEdit = (client) => {
    setFormData(client);
    setOriginalData(client); // Store original data for comparison
    setEditingClientId(client.id);
    setShowForm(true);
  };

  // const handleDelete = async (id) => {
  //   if (window.confirm('Are you sure you want to delete this client?')) {
  //     try {
  //       await api.delete(`/distributor/${id}`);
  //       alert('Client deleted successfully!');
  //       fetchClients();
  //     } catch (error) {
  //       alert(`Error: ${error?.response?.data?.error}`);
  //       console.error(error);
  //     }
  //   }
  // };
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/distributor/${id}`);
          Swal.fire("Deleted!", "The client has been deleted.", "success");
          fetchClients(page);
        } catch (error) {
          Swal.fire("Error", `Failed to delete: ${error?.response?.data?.error}`, "error");
        }
      }
    });
  };


  const handlePageChange = (newPage) => {

    // setPage(newPage);
    if (newPage !== page) {
      setPage(newPage);
    }

  };
  const CustomPagination = () => (
    <>
      <div className='d-flex justify-content-center'>
        <Button
          size="small"
          variant="contained"
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          sx={{ padding: "2px 6px", minWidth: "30px" }} // Reduced padding

        // sx={{ marginRight: 2 }}
        >
          {/* Previous */}
          <ArrowBack fontSize="small" />

        </Button>


        {(clientPage?.length > 0 ? clientPage : [{ label: "1", active: true }, { label: "2", active: false }]).map((link, index) => (
          <Button
            size="small"
            key={index}
            variant={link.active ? "contained" : "outlined"}
            color={link.active ? "primary" : "default"}
            onClick={() => handlePageChange(parseInt(link.label))}
            sx={{ marginX: "2px", padding: "2px 6px", minWidth: "30px", marginLeft: 1 }}
          >
            {link.label}
          </Button>
        ))}
        <Button
          size="small"
          variant="contained"
          onClick={() => handlePageChange(page + 1)}
          disabled={clientPage.length === 0 || page >= clientPage.length}
          sx={{ padding: "2px 6px", minWidth: "30px", marginLeft: 1 }} // Reduced padding

        // sx={{ marginLeft: 2 }}
        >
          {/* Next */}
          <ArrowForward fontSize="small" />

        </Button>
      </div>
    </>
  );







  const generateLink = () => {
    const id = nanoid(10);
    const distid = sessionStorage.getItem("userid")
    const newLink = `${window.location.origin}/share/${distid}/${2}/${id}`;
    console.log("new link", newLink)
    setUniqueLink(newLink)


  }
  const cancelLink = () => {
    setUniqueLink(""); // Reset state to show "Generate Link" button again
  };

  const sendClientLink = (params) => {
    console.log("sendClientLink", params.row.parent_id)
    const token = sessionStorage.getItem("Authorization");
    const email = sessionStorage.getItem("email")
    const clientlink = `${window.location.origin}/editform?parentid=${params.row.parent_id}&email=${email}&clientid=${params.row.id}&type=${2}&token=${token}`
    // setCopiedLink(clientlink)
    setUniqueLink(clientlink)



  }


  const rowsWithIndex = clients.map((item, index) => ({
    ...item,
    idindex: index + 1, // start index from 1
  }));




  return (

    <div className='row p-2' style={{ height: "100%" }}>
      <div className='col-md-12 col-12' style={{ position: "relative" }} >
        <div className='d-flex flex-wrap justify-content-between align-items-center  p-2'>
          <h3 className='distributerfont'>Client</h3>
          <div className="d-flex align-items-center gap-2">
            {

              uniqueLink ? (
                <>
                  <TextareaAutosize
                    // style={{overflow:"hidden",resize:"none",minHeight:"40px",padding:"0.2rem"}}
                    style={{ minWidth: "450px", padding: "0.2rem" }}


                    value={uniqueLink} />
                  <IconButton color="error" onClick={cancelLink}>
                    <CancelOutlined />
                  </IconButton>
                </>
              ) : <button className='generate-button' onClick={generateLink}>Generate Link</button>

            }

            <button
              type="button"
              className="fixed-width-button"
              onClick={() => {
                setShowForm(!showForm);
                setFormData({
                  parent_id,
                  type: 2,
                  name: "",
                  username: "",
                  lastname: "",
                  email: "",
                  phone: "",
                  address: "",
                  organisation: "",
                  country_id: "",
                  language: "English"
                });
              }}
            >
              {showForm ? "List Client" : "Add Client"}
            </button>
          </div>

        </div>

        {showForm ? (
          <div className='distributerbgimage rounded-3 shadow d-flex justify-content-center align-items-center'>
            <div className='formwidthBgImage py-1 px-5 m-3 shadow rounded-5'>
              <form onSubmit={handleFormSubmit}>
                {[
                  { label: 'Name', name: 'name', type: 'text', required: true },
                  { label: "Username", name: 'username', type: "text" },
                  // {label:"Firstname",name:'firstname',type:"text"},
                  { label: "Lastname", name: 'lastname', type: "text" },

                  { label: "0rganisation", name: "organisation", type: "text" },
                  // { label: 'Password', name: 'password', type: 'password'},
                  { label: 'Email', name: 'email', type: 'email' },
                  { label: 'Phone Number', name: 'phone', type: 'text' },
                ].map((field) => (
                  <div key={field.name} className='col-md-6 col-12'>
                    <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
                    <input
                      className='form-control'
                      name={field.name}
                      type={field.type}
                      placeholder={field.label}
                      value={formData[field.name]}
                      onChange={handleChange}
                      required={field.required}

                    />
                    {errors[field.name] && <small className="text-danger">{errors[field.name]}</small>}
                  </div>
                ))}
                <div className='col-md-6 col-12'>
                  <label htmlFor='language' className='form-label distributerfont'>Language</label>
                  <select
                    className='form-control'
                    name='language'
                    value={formData.language}
                    onChange={handleChange}

                  >
                    <option value="English" >English</option>
                    <option value="Arabic">Arabic</option>
                    <option value="Malayalam">Malayalam</option>


                  </select>
                </div>

                <div className='col-md-6 col-12'>
                  <label htmlFor='address' className='form-label distributerfont'>Address</label>
                  <textarea
                    className='form-control'
                    placeholder='Address'
                    name='address'
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>


                <div className='col-md-6 col-12'>
                  <label htmlFor='country' className='form-label distributerfont'>Country</label>
                  <select className='form-control'
                    name='country_id'
                    onChange={handleChange}
                    value={formData.country_id}
                  >
                    <option value="" ></option>
                    {
                      countrylist.map((country) => (
                        <option value={country.id}>{country.name}</option>

                      ))
                    }

                  </select>
                </div>

                <div className='d-flex justify-content-end align-items-center py-2'>
                  <Button variant="outlined" color="secondary" onClick={() => setShowForm(false)}>Cancel</Button>
                  <Button type='submit' variant="contained" color="primary" className='m-1'>
                    {editingClientId ? "Update" : "Submit"}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <>
            <div style={{ height: "23rem", width: '100%' }}>
              <DataGrid
                rows={rowsWithIndex}
                columns={[
                  { field: 'idindex', headerName: 'ID', width: 70 },
                  { field: 'name', headerName: 'Name', width: 150 },
                  // { field: 'email', headerName: 'Email', width: 200 }

                  { field: 'phone', headerName: 'Phone', width: 150 },
                  { field: 'address', headerName: 'Address', width: 200 },
                  {
                    field: 'email_verify_status', headerName: 'Email Status', width: 100, renderCell: (params) => (
                      <Tooltip title={params.value == 1 ? "Verified" : "Not Verfied"}>
                        {
                          params.value == 1 ? (
                            <VerifiedIcon style={{ color: 'green' }} />
                          ) :
                            (
                              <EmailIcon style={{ color: 'red' }} />
                            )
                        }
                      </Tooltip>
                    )
                  },
                  {
                    field: 'actions', headerName: 'Actions', width: 'auto', renderCell: (params) => (<>
                      {/* <IconButton  onClick={() => navigate(`/order/${params.row.parent_id}`)}>
                                 <AddCircleRoundedIcon />
                               </IconButton>
                     <IconButton color="primary" onClick={() => handleEdit(params.row)}><EditIcon /></IconButton>
                     <IconButton color="secondary" onClick={() => handleDelete(params.row.id)}><DeleteIcon /></IconButton> */}
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", gap: 10 }}>


                        <Tooltip title="Add Product">
                          <Link to={`/clientproductlist/${params?.row?.id}`}>
                            <AddShoppingCartIcon style={{ color: 'black' }} />
                            {/* <img src={addProduct} alt="Add Product" width={40} height={40} /> */}
                          </Link>

                        </Tooltip>
                        {
                          params.row.email_verify_status == 0 && (
                            <Tooltip>
                              <EditIcon
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEdit(params.row)}
                              />

                            </Tooltip>
                          )
                        }
                        <Tooltip title="send link to client">
                          <button
                            className='sentlink-button'
                            onClick={() => sendClientLink(params)}
                          > Sent Link</button>
                        </Tooltip>

                      </div>



                    </>)
                  }

                  // {
                  //   field: 'actions',
                  //   headerName: 'Actions',
                  //   width: 100,
                  //   renderCell: (params) => (
                  //     <IconButton color="primary" onClick={() => handleEdit(params.row)}>
                  //       <EditIcon />
                  //     </IconButton>
                  //                           <IconButton color="secondary" onClick={() => handleDelete(params.row.id)}><DeleteIcon /></IconButton>

                  //   ),
                  // },
                  // { field: 'actions', headerName: 'Actions', width: 150, renderCell: (params) => (<>
                  //  <IconButton  onClick={() => navigate(`/order/${params.row.parent_id}`)}>
                  //               <AddCircleRoundedIcon />
                  //             </IconButton>
                  //   <IconButton color="primary" onClick={() => handleEdit(params.row)}><EditIcon /></IconButton>
                  //   <IconButton color="secondary" onClick={() => handleDelete(params.row.id)}><DeleteIcon /></IconButton>
                  // </>) }
                ]}
                loading={loading}
                pagination={false} // Disables pagination
                hideFooter
              // checkboxSelection
              />
            </div>
            <div className={isMobile ? 'pagination-mobile' : 'pagination-content'}>
              <CustomPagination />
            </div>
          </>
        )}

      </div>

      {/* <div className='col-md-3 col-12 distributerSideimage rounded-5 mt-md-0 mt-2 distributerfont'>
        <div className='bg-white my-4 mx-2 p-3 rounded-5'>
          <h5>Details</h5>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.</p>
        </div>
      </div> */}
    </div>

  );
}

export default Clients;
